import {connect} from 'react-redux'
import {Link, withRouter} from 'react-router-dom'

import PageLayout from '../../containers/Layout/PageLayout.jsx'

import {isAdmin} from '../../../shared/services/userService.js'

const MustBeAdmin = function (Component) {
  let MustBeAdminComponent = (props) => {
    const {
      loading,
      isAdmin,
      ...rest
    } = props

    if (loading) {
      return null
    }

    if (!isAdmin) {
      return (
        <PageLayout>
          <h2 className="text-center">
            Impossible d'acceder a ce contenu
          </h2>
          <p className="text-center mb-5">
            Vous devez être connecté pour pouvoir acceder a cette page
          </p>
          <p className="text-center">
            <Link
              className="btn btn-primary"
              to={{
                pathname: '/login',
                state: {redirectTo: props.location.pathname}
              }}
            >Se connecter</Link>
          </p>
        </PageLayout>
      )
    }

    return <Component {...rest}/>
  }

  return connect(
    state => ({
      loading: state.currentUser.loading,
      isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
    })
  )(withRouter(MustBeAdminComponent))
}

export default MustBeAdmin